import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker
const getBinders = state => state.binders

const binder_save_lessons_selector = createSelector(
	[ getLessonsPicker, getBinders ],
	(lessons_picker, binders) => ({
		entityUID: binders.current.entityUID,
		presentationUIDs: lessons_picker.selected_lessons,
	})
)

export default binder_save_lessons_selector
